export const graphCards = [
  {
    title: 'Resistance frequencies within genotypes',
    description: ['Top Genotypes (up to 7)'],
    id: 'RFWG'
  },
  {
    title: 'Drug resistance trends',
    description: ['Data are plotted for years with N ≥ 10 genomes'],
    id: 'DRT'
  },
  {
    title: 'Resistance determinants within genotypes',
    description: ['Top Genotypes (up to 10)'],
    id: 'RDWG'
  },
  {
    title: 'Genotype distribution',
    description: [],
    id: 'GD'
  }
];
